import { AxiosRequestConfig } from 'axios'
import { axios, getConfigs, IRequestConfig } from './api'
import { PaginatedDto } from './extendedType'

export class BaseCrudService<TEntity, TCreateDto, TUpdateDto, TFilters> {
  protected readonly configOptions: Partial<AxiosRequestConfig>;

  constructor(
    protected readonly endpoint: string,
    protected readonly baseUrl?: string,
  ) {
    this.configOptions = this.baseUrl ? { baseURL: this.baseUrl } : {}
  }

  private getContentType(data?: any): string {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      return 'multipart/form-data'
    }
    return 'application/json'
  }

  protected buildConfig(
    method: string,
    url: string,
    data?: any,
    params?: Record<string, unknown>,
  ): IRequestConfig {
    const contentType = this.getContentType(data)
    const configs: IRequestConfig = getConfigs(
      method,
      contentType,
      url,
      this.configOptions,
    )

    if (data) configs.data = data
    if (params) configs.params = params
    return configs
  }

  getAll(query: TFilters): Promise<PaginatedDto<TEntity>> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', this.endpoint, undefined, query as any)
      axios(configs, resolve, reject)
    })
  }

  getOne(id: number | string): Promise<TEntity> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/${id}`)
      axios(configs, resolve, reject)
    })
  }

  create(dto: TCreateDto | FormData): Promise<TEntity> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('post', this.endpoint, dto)
      axios(configs, resolve, reject)
    })
  }

  update(id: number | string, dto: TUpdateDto | FormData): Promise<TEntity> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}`, dto)
      axios(configs, resolve, reject)
    })
  }

  remove(id: number | string): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('delete', `${this.endpoint}/${id}`)
      axios(configs, resolve, reject)
    })
  }
}
